import { PaymentType } from '@truepill/tpos-types'
import type { RXFillRequest } from 'types'

const isInsuranceFill = (rxFillRequest: RXFillRequest | undefined): boolean =>
  rxFillRequest?.paymentType === PaymentType.Insurance

export default isInsuranceFill
